import type { EditControlProps } from '../../declare'
import { useState, useEffect, useContext } from 'react'
import { autorun } from 'mobx'
import { Select } from 'antd'
import { ListTableContext } from 'src/components'
import { appStore } from 'src/stores'

const EnumSelect = (props: EditControlProps) => {
  const table = useContext(ListTableContext)

  const handleChange = (value: any) => {
    props.onChange?.(value)
  }

  const [options, setOptions] = useState([])
  useEffect(() => autorun(() => {
    const find = table.tableConfig?.Nav_Enums?.find((item: any) => item.EnumName === props.config.ENUM)
    if (find?.options) {
      setOptions(find.options)
    } else {
      appStore.getEnums([props.config.ENUM]).then((data: any[]) => {
        setOptions(appStore.getEnumOptions(props.config.ENUM, data))
      })
    }
  }), [props.config.ENUM])

  const { __READONLY__, EDITABLE } = props.config
  return (
    <Select
      allowClear
      disabled={__READONLY__ || !EDITABLE}
      value={props.value !== undefined ? Number(props.value) : props.value}
      options={options}
      onChange={handleChange}
    />
  )
}

export default EnumSelect